var _defs, _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgMargarita(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 105.06 124.49",
    width: "1em",
    height: "1em"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".margarita_svg__cls-1{fill:none;stroke:#000;stroke-linecap:round;stroke-miterlimit:10;stroke-width:18px}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "margarita_svg__Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "margarita_svg__Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "margarita_svg__cls-1",
    d: "M3 3v5.39A22.63 22.63 0 0025.71 31a5.58 5.58 0 014.39 5.43 22.43 22.43 0 1044.86 0v-1.04A4.37 4.37 0 0179.34 31a22.64 22.64 0 0022.72-22.61V3M52.53 110.37V59.2M28.87 121.49h47.32M52.53 110.37l10.95 10.96M52.53 110.37L41.7 121.21"
  })))));
}

var MemoSvgMargarita = /*#__PURE__*/React.memo(SvgMargarita);
export default MemoSvgMargarita;